import React, { useRef } from "react";
import { useLanguage } from "../context/LanguageContext";
import { getTranslations } from "../data/translations/index";
import { useReveal } from "../hooks/useReveal";
import "../styles/AboutItem.css";

export const AboutItem = () => {
  const { language } = useLanguage();
  const { About } = getTranslations(language);
  const rootRef = useRef(null);
  useReveal(rootRef, language);

  const images = About.find((section) => section.images)?.images ?? [];

  return (
    <div className="about container" ref={rootRef}>
      <div className="about__body glass glass--strong" data-reveal>
        {About.map((section, index) => (
          <section key={section.title ?? index} className="about__section">
            {section.title && (
              <h2 className="about__title">{section.title}</h2>
            )}
            {section.content
              ?.split("\n\n")
              .filter(Boolean)
              .map((paragraph, i) => (
                <p key={i}>{paragraph}</p>
              ))}
          </section>
        ))}
      </div>

      <aside className="about__media">
        {images.map((img, index) => (
          <figure
            className="about__figure glass glass--interactive"
            key={img}
            data-reveal
            style={{ "--reveal-delay": `${index * 0.08}s` }}
          >
            <img src={img} alt={`Viktoryia Varanchuk ${index + 1}`} />
          </figure>
        ))}
      </aside>
    </div>
  );
};
